import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/main',
      name: 'admin',
      component: () => import('_c/admin'),
      children: [
        {
          path: '/main/recordDetails',
          component: () => import('_c/recordDetails')
        },
        {
          path: '/main/menuManage',
          component: () => import('_c/menuManage')
        },
        {
          path: '/main/saleRecord',
          component: () => import('_c/salesRecord')
        },
        {
          path: '/main/summary',
          component: () => import('_c/summary')
        },
        {
          path: '/main/faceAdmin',
          component: () => import('_c/faceAdmin')
        }

      ]
    },
    {
      path: '/',
      name: 'Login',
      component: () => import('_c/login')
    }
  ]
})
